<div class="health-container" *ngIf="generatorHealth?.Table?.length">
    <ng-container *ngIf="generatorHealth.Table[0] as summary">
        
        <div class="summary-card">
            <div class="status-badge" [ngClass]="summary.SummaryStatus">
                {{ summary.SummaryStatus === 'HEALTHY' ? '✅' : summary.SummaryStatus === 'CAUTION' ? '⚠️' : summary.SummaryStatus === 'WARNING' ? '🔶' : '🚨' }} 
                {{ summary.SummaryStatus }}
            </div>
            
            <div class="summary-content">
                <div class="summary-text">
                    <strong>{{ summary.SummaryText }}</strong>
                </div>
                <div class="next-step" *ngIf="summary.NextStep">
                    📌 <strong>اقدام بعدی:</strong> {{ summary.NextStep }}
                </div>
            </div>
            
            <div class="score-circle" [style.background]="'conic-gradient(' + (summary.Score >= 80 ? '#50cd89' : summary.Score >= 60 ? '#ffc700' : '#f1416c') + ' 0% ' + summary.Score + '%, #2b2b40 ' + summary.Score + '% 100%)'">
                <span class="score-text">{{ summary.Score }}</span>
            </div>
        </div>

        <div class="metrics-grid">
            <div class="metric-card" [ngClass]="summary.CurrentUnbalance_Max > 25 ? 'border-danger' : summary.CurrentUnbalance_Max > 10 ? 'border-warning' : 'border-good'">
                <div class="label">
                    عدم تعادل جریان
                    <small>({{ getImbalanceStatus(summary.CurrentUnbalance_Max) }})</small>
                </div>
                <div class="value">{{ summary.CurrentUnbalance_Max }} %</div>
                <div class="sub-value">میانگین: {{ summary.CurrentUnbalance_Avg | number:'1.1-2' }}%</div>
            </div>

            <div class="metric-card" [ngClass]="summary.VoltageUnbalance_Max > 8 ? 'border-danger' : summary.VoltageUnbalance_Max > 3 ? 'border-warning' : 'border-good'">
                <div class="label">
                    عدم تعادل ولتاژ
                    <small>({{ getImbalanceStatus(summary.VoltageUnbalance_Max) }})</small>
                </div>
                <div class="value">{{ summary.VoltageUnbalance_Max }} %</div>
                <div class="sub-value">میانگین: {{ summary.VoltageUnbalance_Avg | number:'1.1-2' }}%</div>
            </div>

            <div class="metric-card" [ngClass]="summary.PF_Avg < 0.8 ? 'border-warning' : 'border-good'">
                <div class="label">
                    ضریب توان PF 
                    <small>({{ getImbalanceStatus(summary.VoltageUnbalance_Max) }})</small>
                </div>
                <div class="value">{{ summary.PF_Avg | number:'1.2-2' }}</div>
                <div class="sub-value">حداقل: {{ summary.PF_Min }}</div>
            </div>

            <div class="metric-card" [ngClass]="(summary.Freq_Avg < 47 || summary.Freq_Avg > 53) ? 'border-danger' : summary.Freq_Fluct > 1.5 ? 'border-warning' : 'border-good'">
                <div class="label">فرکانس</div>
                <div class="value">{{ summary.Freq_Avg | number:'1.1-2' }} Hz</div>
                <div class="sub-value">نوسان: {{ summary.Freq_Fluct | number:'1.1-2' }}Hz</div>
            </div>

            <div class="metric-card" [ngClass]="summary.OilTemp_Max >= 105 ? 'border-danger' : summary.OilTemp_Max >= 95 ? 'border-warning' : 'border-good'">
                <div class="label">دمای روغن</div>
                <div class="value">{{ summary.OilTemp_Max }} °C</div>
                <div class="sub-value">میانگین: {{ summary.OilTemp_Avg | number:'1.0-1' }}°C</div>
            </div>

            <div class="metric-card" [ngClass]="summary.WaterTemp_Max >= 100 ? 'border-danger' : summary.WaterTemp_Max >= 90 ? 'border-warning' : 'border-good'">
                <div class="label">دمای آب</div>
                <div class="value">{{ summary.WaterTemp_Max }} °C</div>
                <div class="sub-value">میانگین: {{ summary.WaterTemp_Avg | number:'1.0-1' }}°C</div>
            </div>

            <div class="metric-card" [ngClass]="summary.Load_Avg > 80 ? 'border-warning' : 'border-good'">
                <div class="label">درصد بار</div>
                <div class="value">{{ summary.Load_Avg }} %</div>
                <div class="sub-value">حداکثر: {{ summary.Load_Max }}%</div>
            </div>

            <div class="metric-card" [ngClass]="(summary.RPM_Min < 1400 || summary.RPM_Max > 1600) ? 'border-warning' : 'border-good'">
                <div class="label">دور موتور</div>
                <div class="value">{{ summary.RPM_Avg }} RPM</div>
                <div class="sub-value">بازه: {{ summary.RPM_Min }} - {{ summary.RPM_Max }}</div>
            </div>
        </div>

        <div class="findings-section">
            <h2>📋 یافته‌ها و راهکارها</h2>
            
            <div *ngIf="!generatorHealth.Table1 || generatorHealth.Table1.length === 0" class="empty-state">
                ✅ هیچ یافته‌ای وجود ندارد. ژنراتور در وضعیت سالم است.
            </div>

            <div class="table-responsive" *ngIf="generatorHealth.Table1 && generatorHealth.Table1.length > 0">
                <table class="findings-table">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th style="width: 100px;">کد</th>
                            <th style="width: 120px;">وضعیت</th>
                            <th>عنوان</th>
                            <th>پیام</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of generatorHealth.Table1; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td><code>{{ item.FindingCode }}</code></td>
                            <td>
                                <span class="severity-badge" [ngClass]="item.Severity">
                                    {{ item.Severity === 'CRITICAL' ? 'بحرانی' : item.Severity === 'WARNING' ? 'هشدار' : 'اطلاعاتی' }}
                                </span>
                            </td>
                            <td><strong>{{ item.Title }}</strong></td>
                            <td class="message-cell">{{ item.Message }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </ng-container>
</div>
